<template>
  <div>
    <div class="d-flex justify-content-between align-items-center">
      <h3>{{ backofficeRole === "super-admin" ? 'Single-' : ''}}Communities</h3>
      <button v-if="backofficeRole !== 'community-manager'" @click="$router.push('/communities/add')" type="button" class="btn btn-primary btn-sm d-flex align-items-center">
        <img class="mr-2" src="../../assets/icons/pencil.svg" /> Neue {{ backofficeRole === "super-admin" ? 'Single-' : ''}}Community anlegen
      </button>
    </div>
    <List :columns="columns" :values="communities" emptyText="Bisher keine Communities vorhanden">
      <template #column_communityManagers="{data}">
        <div @click.prevent="$router.push('/communities/' + data.id + '/community-manager')">{{ data.communityManagers }}</div>
      </template>
      <template #column_action="{data}">
        <div class="actions">
          <img v-if="backofficeRole === 'community-manager' && data.pendingModeratorRequests" @click="$router.push('/communities/' + data.id + '/access-requests/')" src="../../assets/icons/Check-filled.svg" />
          <img @click="$router.push(`/communities/${data.id}/${backofficeRole === 'community-manager' ? 'moderators' : 'community-manager'}`)" src="../../assets/icons/users.svg" />
          <img @click="$router.push('/communities/' + data.id)" src="../../assets/icons/settings.svg" />
        </div>
      </template>
      <template #column_createdAt="{data}">{{ data.createdAt | dateFormat }}</template>
    </List>
  </div>
</template>

<script>
import {broadcast} from "@/util/eventHandler.js";
import List from "@/components/partial/List.vue";
import {getBackofficeRole} from "@/util/authenticator";

export default {
  components: {List},
  name: "Communities",
  data() {
    return {
      backofficeRole: "",
      columns: []
    };
  },
  computed: {
    communities() {
      return this.$store.state.communities;
    }
  },
  created() {
    this.loadCommunities();
    this.backofficeRole = getBackofficeRole();
    this.columns = [
      { name: "Name", key: "name" },
      { name: "Beschreibung", key: "description" },
      { name: this.backofficeRole === "community-manager" ? "Moderatoren" : "Community Manager",
        key: this.backofficeRole === "community-manager" ? "moderators": "communityManagers", styles: { "min-width": "175px" } },
      { name: "Aktion", key: "action", styles: { width: "100px" } },
      { name: "Erstellt", key: "createdAt", styles: { width: "100px" } }
    ];
  },
  methods: {
    async loadCommunities() {
      console.log("Load communities...");
      try {
        await this.$store.dispatch("FETCH_COMMUNITIES");
      } catch (e) {
        broadcast("error", e);
      }
    },
  }
};
</script>

<style lang="scss">
.actions {
  display: flex;
  gap: 10px;

  > img:hover {
    cursor: pointer;
  }
}
</style>
